import React from 'react';

const LegalFooter = () => {
  return (
    <footer className="legal-footer bg-gray-900 text-white py-12">
      <div className="container">
        <div className="footer-content text-center">
          <div className="footer-brand mb-8">
            <div className="flex items-center justify-center gap-3 mb-4">
              <img 
                src="https://botley.co.il/assets/logo.png" 
                alt="Botley Logo" 
                className="h-10 w-auto"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <span className="text-2xl font-bold">Botley</span>
            </div>
          </div>
          
          <div className="disclaimer bg-gray-800 p-6 rounded-xl mb-8 max-w-4xl mx-auto">
            <p className="text-gray-300 leading-relaxed">
              המידע הניתן ע״י הסוכן הוא מידע כללי ואינו מהווה ייעוץ משפטי. לצורך ייעוץ פרטני יש לפנות לעו״ד.
            </p>
          </div>
          
          <div className="footer-links flex flex-col sm:flex-row gap-6 justify-center">
            <a 
              href="#/privacy" 
              className="text-gray-300 hover:text-white transition-colors"
            >
              מדיניות פרטיות
            </a>
            <a 
              href="#/terms" 
              className="text-gray-300 hover:text-white transition-colors"
            >
              תנאי שימוש
            </a>
          </div>
          
          <div className="copyright mt-8 pt-8 border-t border-gray-700">
            <p className="text-gray-400">
              © 2024 Botley. כל הזכויות שמורות.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;